<template>
  <div class="content" ref="content">
    <div class="title_box">
      <div class="title_check">远程核验</div>
      <div class="title_tip">更快　更稳定　更安全</div>
    </div>
    <div class="facecheck">
      <img height="100%" src="../../assets/facecheck.png" />
    </div>
    <div class="download">
      <div class="downBtn">
        <img height="35" src="../../assets/ios.png" />
        <div @click="downApp('Iphone')">Iphone下载</div>
      </div>
      <div class="downBtn">
        <img height="35" src="../../assets/android.png" />
        <div @click="downApp('Android')">Android下载</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "instructions",
  data() {
    return {};
  },
  methods: {
    downApp(type) {},
    clickDownload() {
      // setTimeout(function () {
      //   if (!document.hidden) {
      //     // 在4秒内如果页面出去了。说明这个时候document.hidden是true,这段代码就不执行了。
      //     // 就算是再切回来也是不执行的。
      //     // 如果你进了这个函数，没离开。。那就会在4秒后跳进这里
      //     alert("你还没安装，去下载去");
      //     // 去某个下载页面
      //     // const u = navigator.userAgent;
      //     let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      //     let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      //     if (isiOS) {
      //       // 去下载ios
      //     }
      //     if (isAndroid) {
      //       // 去下载安卓
      //     }
      //   }
      // }, 4000);
      const a = document.createElement("a");
      a.href = "test://abc";
      a.click();
    },
  },
  mounted() {
    this.clickDownload();
  },
};
</script>

<style  scoped>
.content {
  background: url(../../assets/background.png) no-repeat center;
  height: 100%;
  background-size: 100% 100%;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}
.title_box {
  padding-top: 50px;
}
.title_check {
  font-size: 48px;
  font-style: italic;
  color: #fff;
  letter-spacing: 10px;
}
.title_tip {
  font-size: 24px;
  color: #fff;
  margin-top: 15px;
}
.facecheck {
  height: 300px;
}
.download {
  display: flex;
  width: 100%;
  justify-content: space-around;
}
.downBtn {
  width: 150px;
  height: 50px;
  font-size: 18px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #fff;
  border-radius: 5px;
}
</style>